import React from "react";
import { chunkArray } from "../Utility/function";
import { Document, Page, Text, View, StyleSheet, PDFViewer, PDFDownloadLink, Font, Image  } from '@react-pdf/renderer';
import Prompt from "../assets/fonts/Sarabun/Prompt-Bold.ttf";

Font.register(
  {
    family: "Prompt",
    src: Prompt,
  }
);

function MiniNoPro({
    data
}) {

  return    <Document style={{ fontFamily: "Prompt", fontSize:13  }} >
                {chunkArray(data,45).map((item,index)=>{
                    return <Page size="A4" key={index}  >
                            <View style={{ flexWrap:'wrap', flexDirection:'row', marginLeft:10, marginTop:10 }} >
                                {item.map((a,i)=>{
                                    const { name, unit, price, barcode, barcodeImage } = a;
                                    return <View key={i} style={{width:"110px",alignItems:'center', borderWidth:0.5}} >
                                                <View style={{backgroundColor:'#eb9e34', width:'100%', height:"33px", justifyContent:'center', alignItems:'center' }} >
                                                    <Text style={{ fontSize:9 }} numberOfLines={2} >{name}</Text>
                                                </View>
                                                <View style={{flexDirection:'row',alignItems:'flex-end', marginTop:-5, justifyContent:'space-around', width:'100%' }} >
                                                    <Text style={{ fontSize:7 }}>({unit})</Text>
                                                    <Text style={{ fontSize:28, marginBottom:-7, paddingBottom:0 }} >{price}</Text>
                                                    <Text style={{ fontSize:10 }}>บาท</Text>
                                                </View>
                                                <Text style={{ fontSize:7 }} >{barcode}</Text>
                                                {barcodeImage && <Image style={{ width:'80px'}} src={barcodeImage} />}
                                            </View>
                                })}
                            </View>
                        </Page>
                })}

            </Document>
}

export default MiniNoPro;
